import type { FC } from 'react';
import { Button } from '@mui/material';
import { useAtom } from 'jotai';

import TourGuideIcon from 'src/assets/svg/tour_guide.svg?react';
import { guidedTourState } from 'src/components/app/context/GuidedTourContext/atom';
import {
  GUIDED_TOUR_BUTTON_ID,
  GuidedTourState,
} from 'src/components/app/context/GuidedTourContext/constants';

import useGuidedTour from '../index';

import { styles } from 'src/components/app/Header/index.styles';

interface GuidedTourButtonProps {
  loading?: boolean;
}

const GuidedTourButton: FC<GuidedTourButtonProps> = ({ loading }) => {
  const [state] = useAtom(guidedTourState);
  const { startTour } = useGuidedTour();

  return state === GuidedTourState.DISABLED ? null : (
    <Button
      onClick={() => {
        startTour();
      }}
      id={GUIDED_TOUR_BUTTON_ID}
      color="inherit"
      sx={styles.guidedTourButton}
      startIcon={<TourGuideIcon />}
      disabled={!!loading}
    >
      Guided Tour
    </Button>
  );
};

export default GuidedTourButton;
